export class JurisdictionLanguage {
  /**
   * @var {string}
   */
  language;

  /**
   * @var {string}
   */
  locale;

  /**
   * @var {string}
   */
  fallbackLocale;

  constructor(language, locale, fallbackLocale) {
    this.language = language;
    this.locale = locale;
    this.fallbackLocale = fallbackLocale;
  }
}
